export default __webpack_public_path__ + "static/media/34FF10C9-3115-49F8-814E-41E6EF7F0DE9_1_102_o.34a28745.jpeg";